import React, { useEffect, useState } from 'react'
import dataGa from 'helpers/dataGa'
import get from 'lodash.get'
import loadable from '@loadable/component'
import renderComponents from 'helpers/renderComponents'
import { snakeToPascal } from 'helpers/strings'
const FlatCards = loadable(() => import('components/organisms/FlatCards'))
const CoverageArea = loadable(() => import('components/organisms/CoverageArea'))

const Plan = (props) => {
  const { data, user, refs } = props
  const entity = get(data, 'route.entity') || { content: [] }
  const preComponents = Array.isArray(entity.preContent) ? entity.preContent : []
  const coverageData = Array.isArray(entity.coverage) ? get(entity, 'coverage') : null
  const coverageTitle = get(entity, 'coverageTitle')
  const coverageDescription = get(entity, 'coverageDescription.value')
  const options = get(entity, 'options')
  const optionsTitle = get(entity, 'optionsTitle')
  const optionsDescription = get(entity, 'optionsDescription')
  const [acessibilityMode, setAcessibilityMode] = useState(false)

  useEffect(() => {
    dataGa(entity.dataGa)
    setAcessibilityMode(JSON.parse(localStorage.getItem('acessibility-mode')) ? true : false)
  }, [])

  return (
    <>
      {preComponents
        .filter((i) => i.entity)
        .map((item, index) => {
          let propsItem =
            item.entity.entityBundle === 'from_library' ? item.entity.entities.entity.paragraphs.entity : item.entity
          propsItem.acessibilityMode = acessibilityMode
          const RenderComponent = renderComponents(snakeToPascal(get(propsItem, 'entityBundle')))
          return <RenderComponent key={index + propsItem.uuid} data={propsItem} user={user} refs={refs} />
        })}

      {optionsTitle && <FlatCards title={optionsTitle} description={optionsDescription} items={options} />}

      {Array.isArray(coverageData) && coverageData.length > 0 && (
        <CoverageArea
          title={coverageTitle}
          description={coverageDescription}
          data={coverageData}
          user={user}
          refs={refs}
        />
      )}
    </>
  )
}

export default Plan
